import { Component, ViewEncapsulation } from '@angular/core';


@Component({
	selector: 'lb-form-row',
	standalone: true,
	imports: [],
	template: '<ng-content></ng-content>',
	styleUrl: './form-row.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class FormRowComponent {}
